module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fbButton",
    staticClass: "fb-wrapper",
    class: {
      'connected': _vm.isConnected
    },
    on: {
      "click": _vm.click
    }
  }, [_c('div', {
    staticClass: "fb-spinner",
    class: {
      'ready': _vm.ready
    }
  }, [(!_vm.ready) ? _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect5"
  })]) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "fb-login-button",
    attrs: {
      "data-auth-type": "rerequest",
      "data-scope": "public_profile,email",
      "data-max-rows": "1",
      "data-size": "medium",
      "data-button-type": "login_with",
      "data-show-faces": "false",
      "data-auto-logout-link": "false",
      "data-use-continue-as": "false"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "small text-muted--ss"
  }, [_vm._v("เราจะไม่โพสต์เนื้อหาใดโดยไม่ได้รับสิทธิ์อนุญาตจากคุณโดยเด็ดขาด")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c232e92","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FacebookLogin.vue
// module id = 1137
// module chunks = 1